/**
 * ポップアップ
 *
 * tracking(=true)属性を指定するとPV/CTのトラッキングが行われます
 */
import React from "react";
import Treasure from "td-js-sdk";
import Template0 from "@/shared/components/popup/templates/type0";
import Template1 from "@/shared/components/popup/templates/type1";
import Template2 from "@/shared/components/popup/templates/type2";

const templates = {
  0: Template0,
  1: Template1,
  2: Template2,
};

const client = {
  connect: {
    writeKey: import.meta.env.VITE_TREASURE_WRITE_KEY,
    database: import.meta.env.VITE_TREASURE_DATA_DB_USER,
    startInSignedMode: true,
    host: window.location.hostname, // ローカル確認時はコメントアウト
  },
};

// テーブル名
const TABLE_POPUP_PV = "site_popup_impression";
const TABLE_POPUP_CT = "site_popup_click";

export default class Popup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      template: null,
      td: new Treasure(client.connect),
    };

    this.handleTrackingCt = this.handleTrackingCt.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  async componentDidMount() {
    const template = templates[this.props.template_id];

    this.setState({
      template: template({
        ...this.props,
        handleTrackingCt: this.handleTrackingCt,
        handleClose: this.handleClose,
      }),
    });

    this.trackingPv();
  }

  /**
   * PVをトラッキング
   *
   * @returns
   */
  trackingPv() {
    if (!this.props.tracking) {
      return;
    }

    (window.dataLayer || []).push({
      event: "popup_IMP",
      eventCategory: "web-tsuku",
      admin_type: this.props.adminType ?? "",
      popup_id: this.props.popup_id,
      popup_type: this.props.template_id,
    });

    const record = {
      site_id: this.props.site_id,
      popup_id: this.props.popup_id,
      hall_id: this.props.hall_id,
      page_type: this.props.page_type,
      st_cid: this.props.tracking,
      admin_type: this.props.adminType ?? "",
      request_ip: this.props.requestIp,
    };

    // impression
    this.state.td.trackEvent(TABLE_POPUP_PV, record);
  }

  /**
   * CTトラッキング&dataLayerデータ送信
   *
   * @param {SyntheticBaseEvent} e
   * @returns
   */
  handleTrackingCt(e) {
    e.preventDefault();

    if (!this.props.tracking) {
      return;
    }

    const { href } = e.currentTarget;

    (window.dataLayer || []).push({
      event: "popup_CT",
      eventCategory: "web-tsuku",
      admin_type: this.props.adminType ?? "",
      popup_id: this.props.popup_id,
      popup_type: this.props.template_id,
    });

    const record = {
      site_id: this.props.site_id,
      popup_id: this.props.popup_id,
      hall_id: this.props.hall_id,
      page_type: this.props.page_type,
      st_cid: this.props.tracking,
      admin_type: this.props.adminType ?? "",
      request_ip: this.props.requestIp,
    };

    this.state.td.trackEvent(TABLE_POPUP_CT, record, () => {
      window.location.href = href;
    });
  }

  /**
   * 閉じる処理
   */
  handleClose() {
    this.setState({ close: true });
  }

  render() {
    return (
      <>
        {this.state.close ? null : (
          <div className="popup is-open">
            <div className="popup-overlay" onClick={this.handleClose} />
            {this.state.template || null}
          </div>
        )}
      </>
    );
  }
}
